var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"mr-2",attrs:{"to":"/transactions","title":"Transactions"}},[(!this.isLoading)?_c('span',[_vm._v(" $ "+_vm._s(_vm.balanceWatcher)+" USD ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }